module.exports = __webpack_public_path__ + "static/media/adult-celebrate2.5e547cf0.jpg";